module.exports = __webpack_public_path__ + "static/media/my_profile_french.2e6487c1.jpg";